import { AlertCircle, Check, CloudUpload, RotateCcw } from "lucide-react";
import { Spinner } from "./components";
import { download } from "./api";
import type { SaveState } from "./types";
export function ResourceStatus({
  resource,
  readOnly = false,
}: {
  readOnly?: boolean;
  resource: {
    state: SaveState;
    message: string;
    data: unknown;
    flush: () => Promise<boolean>;
    useServer: () => void;
    keepLocal: () => Promise<boolean>;
  };
}) {
  const labels = {
    saved: "Сохранено",
    dirty: "Есть изменения",
    saving: "Сохранение…",
    error: "Ошибка сохранения",
    conflict: "Конфликт версий",
  };
  return (
    <div className="resource-status">
      <div className={`save-status ${resource.state}`} role="status">
        {resource.state === "saving" ? (
          <Spinner />
        ) : resource.state === "saved" ? (
          <Check size={15} />
        ) : resource.state === "dirty" ? (
          <CloudUpload size={15} />
        ) : (
          <AlertCircle size={15} />
        )}
        <span>{readOnly ? "Только просмотр" : labels[resource.state]}</span>
      </div>
      {resource.message && (
        <div className="save-notice" role="alert">
          {resource.message} Изменения остаются здесь.
          {resource.state === "error" && (
            <button onClick={() => void resource.flush()}>
              <RotateCcw size={13} />
              Повторить
            </button>
          )}
          {resource.state === "conflict" && (
            <div className="conflict-actions">
              <button
                onClick={() =>
                  download(
                    "local-copy.json",
                    JSON.stringify(resource.data, null, 2),
                    "application/json",
                  )
                }
              >
                Скачать мою копию
              </button>
              <button onClick={resource.useServer}>Загрузить серверную</button>
              <button onClick={() => void resource.keepLocal()}>
                Сохранить мою версию
              </button>
            </div>
          )}
        </div>
      )}
    </div>
  );
}
